import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "inl-page" }
const _hoisted_2 = { class: "hero" }
const _hoisted_3 = { class: "co-chip" }
const _hoisted_4 = { class: "co-val" }
const _hoisted_5 = { class: "grid-card" }
const _hoisted_6 = { class: "grid-head" }
const _hoisted_7 = { class: "ang" }
const _hoisted_8 = { class: "avatar" }
const _hoisted_9 = { class: "ang-nume" }
const _hoisted_10 = { class: "tip-badge" }
const _hoisted_11 = { class: "perioada" }
const _hoisted_12 = { class: "zile-badge" }
const _hoisted_13 = { class: "grid-card" }
const _hoisted_14 = { class: "grid-head" }
const _hoisted_15 = { class: "ang" }
const _hoisted_16 = { class: "avatar" }
const _hoisted_17 = { class: "ang-nume" }
const _hoisted_18 = { class: "tip-badge tip-badge-tichet" }
const _hoisted_19 = { class: "perioada" }
const _hoisted_20 = { class: "zile-badge" }
const _hoisted_21 = { class: "dlg-head" }
const _hoisted_22 = { class: "dlg-ic" }
const _hoisted_23 = { class: "rez" }
const _hoisted_24 = { class: "rez-row" }
const _hoisted_25 = { class: "rez-val" }
const _hoisted_26 = { class: "rez-row" }
const _hoisted_27 = { class: "rez-val" }
const _hoisted_28 = { class: "rez-row" }
const _hoisted_29 = { class: "rez-val" }
const _hoisted_30 = { class: "rez-row" }
const _hoisted_31 = { class: "rez-val" }
const _hoisted_32 = {
  key: 0,
  class: "rez-row"
}
const _hoisted_33 = { class: "rez-val" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxSorting = _resolveComponent("DxSorting")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[7] || (_cache[7] = _createElementVNode("div", { class: "hero-txt" }, [
        _createElementVNode("div", { class: "hero-eyebrow" }, "PORTAL HR"),
        _createElementVNode("h1", { class: "hero-title" }, "Solicitări de înlocuire"),
        _createElementVNode("p", { class: "hero-sub" }, "Cererile în care ești desemnat înlocuitor. Concediile se confirmă ca să meargă la superior; tichetele sunt afișate spre informare.")
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "18",
          class: "mr-1"
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
            _createTextVNode("mdi-account-switch", -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.cereri.length + _ctx.tichete.length), 1),
        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "co-lbl" }, "în așteptare", -1))
      ])
    ]),
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.activeTab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
      class: "inl-tabs",
      color: "#ff5722",
      density: "comfortable"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "concedii" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-2"
            }, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("mdi-calendar-account", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" Concedii (" + _toDisplayString(_ctx.cereri.length) + ") ", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "tichete" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, {
              size: "18",
              class: "mr-2"
            }, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("mdi-ticket-confirmation-outline", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(" Tichete (" + _toDisplayString(_ctx.tichete.length) + ") ", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _withDirectives(_createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "#ff5722",
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
            _createTextVNode("mdi-account-switch-outline", -1)
          ]))]),
          _: 1
        }),
        _cache[11] || (_cache[11] = _createElementVNode("span", null, "Cereri de concediu care așteaptă confirmarea ta", -1))
      ]),
      _createVNode(_component_DxDataGrid, {
        "data-source": _ctx.cereri,
        "key-expr": "ID",
        "show-borders": false,
        "show-column-lines": false,
        "show-row-lines": true,
        "row-alternation-enabled": false,
        "hover-state-enabled": true,
        "no-data-text": _ctx.loading ? 'Se încarcă…' : 'Nicio solicitare de înlocuire.'
      }, {
        angCell: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(data.data.Initiale), 1),
            _createElementVNode("span", _hoisted_9, _toDisplayString(data.data.NumeAngajat || 'Coleg'), 1)
          ])
        ]),
        tipCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_10, _toDisplayString(data.data.TipConcediu || 'CO'), 1)
        ]),
        perioadaCell: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_icon, {
              size: "15",
              color: "#ff5722",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[12] || (_cache[12] = [
                _createTextVNode("mdi-calendar-range", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(_toDisplayString(data.data.PerioadaText), 1)
          ])
        ]),
        zileCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_12, _toDisplayString(data.data.NumarZile), 1)
        ]),
        actiuniCell: _withCtx(({ data }) => [
          _createVNode(_component_v_btn, {
            size: "small",
            class: "btn-confirma",
            "prepend-icon": "mdi-check-circle",
            onClick: ($event: any) => (_ctx.openConfirm(data.data))
          }, {
            default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
              _createTextVNode("Confirmă", -1)
            ]))]),
            _: 1
          }, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxColumn, {
            "data-field": "NumeAngajat",
            caption: "Solicitant",
            "min-width": 180,
            "cell-template": "angCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TipConcediu",
            caption: "Tip",
            width: 130,
            "cell-template": "tipCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PerioadaText",
            caption: "Perioadă",
            width: 210,
            "cell-template": "perioadaCell",
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "NumarZile",
            caption: "Zile",
            width: 80,
            alignment: "center",
            "cell-template": "zileCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Descriere",
            caption: "Descriere",
            "min-width": 160
          }),
          _createVNode(_component_DxColumn, {
            caption: "",
            width: 140,
            "allow-filtering": false,
            "allow-sorting": false,
            "cell-template": "actiuniCell"
          }),
          _createVNode(_component_DxPaging, { "page-size": 12 }),
          _createVNode(_component_DxSorting, { mode: "single" }),
          _createVNode(_component_DxFilterRow, { visible: true })
        ]),
        _: 1
      }, 8, ["data-source", "no-data-text"])
    ], 512), [
      [_vShow, _ctx.activeTab === 'concedii']
    ]),
    _withDirectives(_createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createVNode(_component_v_icon, {
          size: "18",
          color: "#ff5722",
          class: "mr-2"
        }, {
          default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
            _createTextVNode("mdi-ticket-confirmation-outline", -1)
          ]))]),
          _: 1
        }),
        _cache[15] || (_cache[15] = _createElementVNode("span", null, "Tichete în care ești desemnat înlocuitor", -1))
      ]),
      _createVNode(_component_DxDataGrid, {
        "data-source": _ctx.tichete,
        "key-expr": "ID",
        "show-borders": false,
        "show-column-lines": false,
        "show-row-lines": true,
        "row-alternation-enabled": false,
        "hover-state-enabled": true,
        "no-data-text": _ctx.loading ? 'Se încarcă…' : 'Niciun tichet care să te aibă ca înlocuitor.'
      }, {
        tAngCell: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("span", _hoisted_16, _toDisplayString(data.data.Initiale), 1),
            _createElementVNode("span", _hoisted_17, _toDisplayString(data.data.NumeAngajat || 'Coleg'), 1)
          ])
        ]),
        tTipCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_18, _toDisplayString(data.data.TipCerere || 'Tichet'), 1)
        ]),
        tPerioadaCell: _withCtx(({ data }) => [
          _createElementVNode("div", _hoisted_19, [
            _createVNode(_component_v_icon, {
              size: "15",
              color: "#ff5722",
              class: "mr-1"
            }, {
              default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                _createTextVNode("mdi-calendar-range", -1)
              ]))]),
              _: 1
            }),
            _createTextVNode(_toDisplayString(data.data.PerioadaText), 1)
          ])
        ]),
        tZileCell: _withCtx(({ data }) => [
          _createElementVNode("span", _hoisted_20, _toDisplayString(data.data.ZileText), 1)
        ]),
        default: _withCtx(() => [
          _createVNode(_component_DxColumn, {
            "data-field": "NumeAngajat",
            caption: "Solicitant",
            "min-width": 180,
            "cell-template": "tAngCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "TipCerere",
            caption: "Tip cerere",
            width: 150,
            "cell-template": "tTipCell"
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "PerioadaText",
            caption: "Perioadă",
            width: 210,
            "cell-template": "tPerioadaCell",
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "ZileText",
            caption: "Zile / Durată",
            width: 120,
            alignment: "center",
            "cell-template": "tZileCell",
            "allow-filtering": false
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "DestinatieText",
            caption: "Destinație",
            "min-width": 150
          }),
          _createVNode(_component_DxColumn, {
            "data-field": "Explicatie",
            caption: "Explicație",
            "min-width": 180
          }),
          _createVNode(_component_DxPaging, { "page-size": 12 }),
          _createVNode(_component_DxSorting, { mode: "single" }),
          _createVNode(_component_DxFilterRow, { visible: true })
        ]),
        _: 1
      }, 8, ["data-source", "no-data-text"])
    ], 512), [
      [_vShow, _ctx.activeTab === 'tichete']
    ]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialog,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialog) = $event)),
      "max-width": "480"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, {
          rounded: "xl",
          class: "dlg-card"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, [
                _createVNode(_component_v_icon, {
                  color: "#fff",
                  size: "20"
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("mdi-account-check-outline", -1)
                  ]))]),
                  _: 1
                })
              ]),
              _cache[18] || (_cache[18] = _createElementVNode("div", { class: "dlg-txt" }, [
                _createElementVNode("div", { class: "dlg-title" }, "Confirmă înlocuirea"),
                _createElementVNode("div", { class: "dlg-desc" }, "Cererea va merge mai departe la superior.")
              ], -1)),
              _createVNode(_component_v_btn, {
                icon: "mdi-close",
                variant: "text",
                color: "#fff",
                size: "small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.dialog = false))
              })
            ]),
            (_ctx.selectat)
              ? (_openBlock(), _createBlock(_component_v_card_text, {
                  key: 0,
                  class: "pa-5"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_23, [
                      _createElementVNode("div", _hoisted_24, [
                        _cache[19] || (_cache[19] = _createElementVNode("span", { class: "rez-lbl" }, "Solicitant", -1)),
                        _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.selectat.NumeAngajat), 1)
                      ]),
                      _createElementVNode("div", _hoisted_26, [
                        _cache[20] || (_cache[20] = _createElementVNode("span", { class: "rez-lbl" }, "Tip", -1)),
                        _createElementVNode("span", _hoisted_27, _toDisplayString(_ctx.selectat.TipConcediu || 'CO'), 1)
                      ]),
                      _createElementVNode("div", _hoisted_28, [
                        _cache[21] || (_cache[21] = _createElementVNode("span", { class: "rez-lbl" }, "Perioadă", -1)),
                        _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.selectat.PerioadaText), 1)
                      ]),
                      _createElementVNode("div", _hoisted_30, [
                        _cache[22] || (_cache[22] = _createElementVNode("span", { class: "rez-lbl" }, "Zile", -1)),
                        _createElementVNode("span", _hoisted_31, _toDisplayString(_ctx.selectat.NumarZile), 1)
                      ]),
                      (_ctx.selectat.Descriere)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                            _cache[23] || (_cache[23] = _createElementVNode("span", { class: "rez-lbl" }, "Descriere", -1)),
                            _createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.selectat.Descriere), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.observatie,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.observatie) = $event)),
                      label: "Observație / explicație (opțional)",
                      variant: "outlined",
                      density: "comfortable",
                      rows: "2",
                      "hide-details": "",
                      class: "mt-4"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_v_card_actions, { class: "dlg-foot" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialog = false))
                }, {
                  default: _withCtx(() => [...(_cache[24] || (_cache[24] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  class: "btn-confirma px-6",
                  loading: _ctx.confirmand,
                  onClick: _ctx.confirma
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, { start: "" }, {
                      default: _withCtx(() => [...(_cache[25] || (_cache[25] = [
                        _createTextVNode("mdi-check-circle", -1)
                      ]))]),
                      _: 1
                    }),
                    _cache[26] || (_cache[26] = _createTextVNode("Confirmă ", -1))
                  ]),
                  _: 1
                }, 8, ["loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}